<template>
    <div class="pagination">
        <ul>
            <li
                :key=index v-for="(index, n) in size"
                v-bind:class="{ active: (n == currentPage) }"
                @click="changePage(n)"
            >
            {{n + 1}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['size', 'refresh'],
    data() {
        return {
            currentPage: 0
        }
    },
    watch: {
        refresh: function(newVal) {
            if(newVal === true) {
                this.changePage(0)
            }
        }
    },
    methods: {
        changePage: function (n) {
            this.currentPage = n
            this.$emit('changePage', this.currentPage)
        }
    },
}
</script>

<style lang="scss" scoped>
.pagination{
    ul{
        display:flex;
        width: 100%;
        padding: 0;
        margin: 0 auto;
        flex-wrap: wrap;
        justify-content: center;
        li {
            //float: left;
            list-style: none;
            padding: 1rem;
            background:#c0392b;
            color: #fff;
            &:hover {
                cursor: pointer;
            }
            &.active {
                background-color: #e74c3c
            }
        }
    }
}
@media screen and (max-width: 600px) {
}
</style>


